import { api } from '@/constant'
import baseApi from '@/service/api-general'
const program = {
  getInstructorById: (id) => {
    const url = api.instructor.instructorById(id)
    return baseApi.get(url)
  }
}
export default program
